import React from 'react';
import { createContext, useContext } from 'react';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from 'lodash';

import { axios } from '../../../utils/axios';
import { success, successAPI, errorAPI, getMaxPageSize, isNumeric } from '../../../utils/utils';
import Yup from '../../../utils/yup';
// import {  } from '../../../utils/enums';

import { BillingTypes } from '../../jobs/slice';


export const fields = {
  chargeCategoryName: {
    id: 'chargeCategoryName',
    label: 'Name',
    placeholder: ' ',
  },
  billingType: {
    id: 'billingType',
    label: 'Billing Type',
    placeholder: ' ',
  },
  useBinWeightQuantity: {
    id: 'useBinWeightQuantity',
    label: 'Link Billable Weight To Service Item Qty',
    placeholder: ' ',
  },
};


export const formSchema = (id: number|null= null) => {
  return Yup.object().shape({
    chargeCategoryName: Yup.string().required().label(fields.chargeCategoryName.label),
    billingType: Yup.number().nullable().min(0).label(fields.billingType.label),
    useBinWeightQuantity: Yup.bool().oneOf([true, false]).label(fields.useBinWeightQuantity.label),
  })
}


let formikContext: any = null;
export const FormikContext = createContext<any>(null);
export const useFormikContext = () => {
    formikContext = useContext(FormikContext);
    if (!formikContext) {
      throw new Error('useFormikContext must be used within a FormikProvider');
    }
    return formikContext;
};


export const prepareForm = (values: any = null, defValues: any = null) => {
  let form = _.cloneDeep(values);
  let data = _.cloneDeep(defValues);
  
  if(data && form){
    let isActive = ((form.isActive === false) || (form.isActive === true)) ? form.isActive : false;
    let useBinWeightQuantity = ((form.useBinWeightQuantity === false) || (form.useBinWeightQuantity === true)) ? form.useBinWeightQuantity : false;
    let chargeCategoryId = (isNumeric(form.chargeCategoryId)) ? form.chargeCategoryId : 0;
    let chargeCategoryName = (form.chargeCategoryName && form.chargeCategoryName !== '') ? form.chargeCategoryName : '';

    data['isActive'] = isActive;
    data['chargeCategoryId'] = chargeCategoryId;
    data['chargeCategoryName'] = chargeCategoryName;
    data['useBinWeightQuantity'] = useBinWeightQuantity;
    data['billingType'] = form.billingType;
  }
  
  return data;
};
export const prepareData = (values: any = null, id: any = null) => {
  let data: any = {};

  let form = _.cloneDeep(values);

  if(form){
    data['isActive'] = form.isActive;
    data['chargeCategoryName'] = form.chargeCategoryName;
    data['billingType'] = form.billingType;
    data['useBinWeightQuantity'] = form.useBinWeightQuantity;

    if(id){
      data['chargeCategoryId'] = id;
    }
  }

  return data;
};


export interface initialValuesStruct {
  chargeCategoryId: number|null,
  chargeCategoryName: string,
  billingType: number|null,
  useBinWeightQuantity: boolean,
};
export const initialValues: initialValuesStruct = {
  chargeCategoryId: null,
  chargeCategoryName: '',
  billingType: BillingTypes.Invoice,
  useBinWeightQuantity: false,
};


interface InitState {
  isLoading: boolean,
  show: boolean,
  index: number|null,
  id: number|null,
  details: any,

  isLoadingChargeCategoryCheckName: boolean,
}


function NewReducer() {
  const name = 'servicesBillingCategorySlice';


  const initialState: InitState = {
    isLoading: false,
    show: false,
    index: null,
    id: null,
    details: initialValues,

    isLoadingChargeCategoryCheckName: false,
  };


  const reducers = {
    resetSlice: () => {
      return initialState;
    },
    setLoading: (state: InitState, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setValues: (state: InitState, action: PayloadAction<any>) => {
      state.details = action.payload;
    },
    

    setShow: (state: InitState, action: PayloadAction<{ show: boolean, index: number|null, id: number|null }>) => {
      state.isLoading = false;
      state.id = action.payload.id;
      state.index = action.payload.index;
      state.show = action.payload.show;
    },
    

    startDetails: (state: InitState) => {
      state.isLoading = true;
    },
    finishDetails: (state: InitState, action: PayloadAction<any>) => {
      state.details = action.payload;
      state.isLoading = false;
    },
    
    startCreate: (state: InitState) => {
      state.isLoading = true;
    },
    finishCreate: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },

    startUpdate: (state: InitState) => {
      state.isLoading = true;
    },
    finishUpdate: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },

    startDelete: (state: InitState) => {
      state.isLoading = true;
    },
    finishDelete: (state: InitState, action: PayloadAction<any>) => {
      state.isLoading = false;
    },
    
    startChargeCategoryCheckName: (state: InitState) => {
      state.isLoadingChargeCategoryCheckName = true;
    },
    finishChargeCategoryCheckName: (state: InitState, action: PayloadAction<any>) => {
      state.isLoadingChargeCategoryCheckName = false;
    },
  };


  const apis = {
    callDetailsApi: (id: number|null, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startDetails());

      await axios.get('ChargeCategory/' + id).then((result: any) => {
        let data = result.data;

        // successAPI(data);

        callback(true, data);
        dispatch(actions.finishDetails(data));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishDetails(null));
      });
    },

    callCreateApi: (params: any, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startCreate());

      await axios.post('ChargeCategory', params).then((result: any) => {
        let data = result.data;
        
        // successAPI(data);
        // success('Saved successfully', 'The data you entered has been successfully saved.');

        callback(true, data);
        dispatch(actions.finishCreate(data));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishCreate(null));
      });
    },

    callUpdateApi: (params: any, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startUpdate());

      await axios.put('ChargeCategory', params).then((result: any) => {
        let data = result.data;
        
        // successAPI(data);
        // success('Updated successfully', 'Your data has been successfully updated.');

        callback(true, data);
        dispatch(actions.finishUpdate(data));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishUpdate(null));
      });
    },

    callDeleteApi: (params: any, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startDelete());

      await axios.delete('ChargeCategory', { data: params }).then((result: any) => {
        let data = result.data;
            
        // successAPI(data);
        success('Deleted successfully', 'Category has been successfully deleted.');

        callback(true, data);
        dispatch(actions.finishDelete(data));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishDelete(null));
      });
    },

    callChargeCategoryCheckNameApi: (params: any, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startChargeCategoryCheckName());

      await axios.post('ChargeCategory/check-name', params).then((result: any) => {
        let data = result.data;
        
        // successAPI(data);

        callback(true, data);
        dispatch(actions.finishChargeCategoryCheckName(data));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishChargeCategoryCheckName(null));
      });
    },
  };


  const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers,
  });


  return {
    reducer,
    ...actions,
    ...apis,
  };
}


export default NewReducer();